import { render } from "./DeliveryInfo.vue?vue&type=template&id=024823f2"
import script from "./DeliveryInfo.vue?vue&type=script&lang=js"
export * from "./DeliveryInfo.vue?vue&type=script&lang=js"
script.render = render

export default script